export interface ResponsiveImageMedia {
  MQ1: string;
  MQ2: string;
  MQ3: string;
  MQ4: string;
  MQ5: string;
  MQ6: string;
}

export interface ResponsiveImageDimensions {
  MQ1: Dimension;
  MQ2: Dimension;
  MQ3: Dimension;
  MQ4: Dimension;
  MQ5: Dimension;
  MQ6: Dimension;
}

export type Dimension = [number, number]; // [width, height]

export const createDesktopTabletImage = (desktopUrl: string, tabletUrl: string): ResponsiveImageMedia => ({
  MQ1: tabletUrl,
  MQ2: tabletUrl,
  MQ3: tabletUrl,
  MQ4: tabletUrl,
  MQ5: tabletUrl,
  MQ6: desktopUrl
});
